<div class="px-3 md:px-10 xl:px-[175px] w-full max-w-[1920px] mx-auto">
    <div class="absolute z-[-1] top-0 left-0 w-screen h-[614px]"
        style="background:radial-gradient(circle, #719CFF 0%, #283759 100%);"></div>

    <div class="mt-[60px] relative text-222222 text-font40px aspect43:text-center font-normal uppercase">
        <h1 class="text-font36px leading-[40px] font-extrabold mb-2.5 text-center">
            Partner
        </h1>
    </div>

    <div
        class="items-center mb-5 text-white font-normal text-font19px aspect43:text-font26px max-w-[100%] mx-auto flex">
        <div class="text-center text-justify-disabled mx-auto text-font24px font-normal leading-[25px]">
            Vuoi diventare un nostro partner ?
        </div>
    </div>

    <div class="w-full bg-white rounded-[20px] shadow-lg p-5 xl:p-10">
         <div class="aspect43:flex">
            <div class="w-full border-[#222222]">

            <div class="mt-6 text-font24px font-medium text-[#364349] text-justify">
            <h2 class="!text-font24px">
            Spesso, il successo di un progetto di finanza agevolata non dipende solo dall’ottenimento del fondo, ma
            dalla capacità di realizzarlo con i compagni di viaggio giusti. Per questo abbiamo creato il <strong>Catalogo
            Partner di Innovation Plaza</strong>, un punto d'incontro strategico tra chi vuole ottenere un finanziamento e
            chi possiede le competenze tecniche per trasformarlo in realtà.
            <br> <br>Il nostro non è un semplice elenco di aziende, ma un <strong>network d’eccellenza</strong>. 
            Per garantire la massima affidabilità a chi utilizza la nostra piattaforma, l'ingresso nel catalogo segue un iter preciso:
            </h2>
        
    <ol class="list-decimal space-y-4 mb-12 ml-4"> 
        <br>  
<!-- 1 -->
          <li class="text-font24px text-[#364349] ">
            <span class="font-semibold strong">Candidatura e requisiti minimi: </span>
          </li>

        <div class="mt-6 text-font24px font-medium text-[#364349] text-justify">
           <h4 class="!text-font24px indent-0 text-justify">
            Se la tua impresa offre servizi o tecnologie ad alto valore aggiunto (dall'industria 4.0 alla sostenibilità, fino alla digitalizzazione),
            puoi sottoporre la tua candidatura.
           </h4>
        </div>
<!-- 2 -->
          <li class="text-font24px text-[#364349]">
            <span class="font-semibold strong">Il colloquio di validazione: </span>
          </li>

        <div class="mt-6 text-font24px font-medium text-[#364349] text-justify">
           <h4 class="!text-font24px indent-0 text-justify">
            Ogni potenziale partner sostiene un collocquio conoscitivo con i nostri esperti.Verifichiamo i requisiti minimi tecnici e 
            di affidabilità, assicurandoci che la qualità della tua offerta sia in linea con gli standard richiesti dai progetti che gestiamo.
           </h4>
        </div>
<!-- 3 -->
          <li class="text-font24px text-[#364349]">
            <span class="font-semibold strong">Visibilità strategica: </span>
          </li>

        <div class="mt-6 text-font24px font-medium text-[#364349] text-justify">
           <h4 class="!text-font24px indent-0 text-justify">
           Una volta validato, il profilo della tua impresa entra ufficialmente nel nostro Catalogo. Sarai visibile a tutti gli utenti della piattaforma
           - sia Imprese che Pubbliche Amministrazioni - che sono alla ricerca di partner tecnici nella tua specifica sfera di competenze 
           per procedere alla <strong>fase esecutiva</strong> dei loro progetti finanziati.
           </h4>
        </div>
    </ol>

<div class="mt-6 text-font24px font-medium text-[#364349] text-justify">
            <h2 class="!text-font24px">
                E' un opportunità unica per:
            </h2>
        </div>

<div class="flex xl:gap-10 mb-6">
            <div class="w-[49%] xl:w-[calc(100%-20px)]">
            <br>
 <!-- marker blu -->
                <ul class="list-disc pl-5 marker:text-blue-500 space-y-4 top-6 custom-marker">
 <!-- Accedere a nuovi mercati -->
                    <li class="text-font24px text-[#364349] ">
                        <span class="font-semibold strong mb-6">
                            Accedere a nuovi mercati:
                        </span>                        
                    </li>

                    <div class="pl-10 mt-6 text-font24px font-medium text-[#364349] text-justify ">
                        <h4 class="!text-font24px  text-justify">
                            Potrete accedere al nostro servizo di intelligence territoriale e nazionale, attraverso il monitoraggio potrete consultare
                            da un unico punto di accesso tutte le opportunità per 
                            la vostra impresa, verificarne l'ammissibilità preliminare al bando
                            attraverso un semplice click e grazie all'algoritmo AI di ISP.                      
                        </h4>
                    </div> 

 <!-- Certificare la tua competenza -->
                    <li class="text-font24px text-[#364349]">
                        <span class="font-semibold strong mb-6">
                            Certificare la tua competenza:
                        </span>                        
                    </li>

                    <div class="pl-10 mt-6 text-font24px font-medium text-[#364349] text-justify ">
                        <h4 class="!text-font24px text-justify">
                            Il badge di "Partner Validato Innovation Plaza" è un segnale di fiducia per tutto il mercato.
                        </h4>
                    </div> 

 <!-- Creare sinergie -->
                    <li class="text-font24px text-[#364349]">
                        <span class="font-semibold strong mb-6">
                            Creare sinergie:
                        </span>                        
                    </li>

                    <div class="pl-10 mt-6 text-font24px font-medium text-[#364349] text-justify ">
                        <h4 class="!text-font24px  text-justify">
                            Partecipa a progetti di ampio respiro, spesso in collaborazione con altri attori del network o con 
                            la Pubblica Amministrazione.
                        </h4>
                    </div>
                </ul>

  <!-- cointainer contattaci -->
<div class="mt-12 p-6 bg-gradient-to-r from-violet-50 via-indigo-50 to-purple-50 rounded-xl border-l-4 border-violet-500">
         <div class="aspect43:flex place-content-center mt-10 gap-20">
            <div>
                <div class="text-[#222222] text-font24px font-bold mb-5 text-justify"> 
                    Hai le competenze per trasformare i progetti in realtà? Richiedi il tuo colloquio di validazione 
                    e unisciti al nostro Catalogo Partner.
                </div>
                <div (click)="goTo()"
                    class="my-5 w-1/4 bg-purple-600 cursor-pointer rounded-full text-center p-4 text-font16px text-Swhite font-semibold mx-auto">
                    CONTATTACI</div>
            </div>
          </div>         
      </div>